export const EMAIL_TEMPLATES_PAGE_TITLE = {
    id: 'oe.emailTemplatesPage.pageTitle',
    defaultMessage: 'Email Templates',
    description: 'Section header'
};

export const TEMPLATE_NAME = {
    id: 'oe.emailTemplatesPage.templateName',
    defaultMessage: 'Template Name',
    description: 'Text message'
};

export const TO = {
    id: 'oe.emailTemplatesPage.to',
    defaultMessage: 'To:',
    description: 'Text message'
};

export const REPLY_TO = {
    id: 'oe.emailTemplatesPage.replyTo',
    defaultMessage: 'Reply To:',
    description: 'Text message'
};

export const NEW_EMAIL_TEMPLATE = {
    id: `oe.emailTemplates.newEmailTemplate`,
    description: 'Button text',
    defaultMessage: '{prefix}New Email Template',
};

export const EMAIL_TEMPLATES_LIST_EMPTY = {
    id: `oe.emailTemplates.emailTemplatesEmptyList`,
    defaultMessage: 'No Email Templates have been created in this account.',
    description: 'Text',
};

export const EMAIL_TEMPLATE_IS_BEING_SAVED = {
    description: 'Placeholder text',
    defaultMessage: 'Template is being saved, please wait...',
    id: 'oe.emailTemplates.emailTemplateIsBeingSaved',
};

export const NEW_EMAIL_TEMPLATE_ADDED = {
    id: 'oe.emailTemplates.templateAdded',
    description: 'Notification text',
    defaultMessage: 'New Email Template added',
};

export const EDIT_EMAIL_TEMPLATE = {
    id: 'oe.emailTemplates.editEmailTemplate',
    description: 'Text',
    defaultMessage: 'Edit Email Template',
};

export const EMAIL_TEMPLATE_UPDATED = {
    id: 'oe.emailTemplates.emailTemplateUpdated',
    description: 'Text',
    defaultMessage: 'Email Template updated',
};
export const LOADING_EMAIL_TEMPLATES = {
    id: 'oe.emailTemplates.loadingEmailTemplates',
    description: 'Text',
    defaultMessage: 'Loading email templates',
};
export const LOADING_EMAIL_TEMPLATE_DATA = {
    id: 'oe.emailTemplates.loadingEmailTemplateData',
    description: 'Text',
    defaultMessage: 'Loading email template data',
};

export const EMAIL_TEMPLATE_DELETED = {
    id: 'oe.emailTemplates.emailTemplateDeleted',
    description: 'Text',
    defaultMessage: 'Email Template deleted',
};

export const DELETE_EMAIL_TEMPLATE_TEXT = {
    id: 'oe.emailTemplates.deleteEmailTemplate',
    defaultMessage: 'Delete Template',
    description: 'Label text'
};

export const DELETE_EMAIL_TEMPLATE_POPUP_TEXT = {
    id: 'oe.blueprints.deleteEmailTemplatePopup',
    description: 'Confirm message',
    defaultMessage: 'delete this Template?',
};

export const DELETE_EMAIL_TEMPLATE_UNDONE_TEXT = {
    id: 'oe.blueprints.deleteEmailTemplateUndone',
    description: 'Confirm message',
    defaultMessage: 'cannot be undone.',
};

export const DELETE_EMAIL_TEMPLATE_PERMANENT_TEXT = {
    id: 'oe.blueprints.deleteEmailTemplatePermanent',
    description: 'Confirm message',
    defaultMessage: 'This deletion will be permanent and',
};
